import { styled } from 'goober';
import { Link } from 'react-router-dom';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #c5c7d4;
  border-radius: 6px;

  @media (min-width: 768px) {
    flex-direction: row;
    border: none;
  }
`;

const FlexGrow = styled.div`
  flex-grow: 1;

  @media (min-width: 768px) {
    border-bottom: 1px solid #3097cc;
  }
`;

const Tab = styled(Link)`
  font-family: 'Noto Sans', sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: #242527;
  padding: 8px 14.5px;
  border-bottom: none;
  text-decoration: none;
  border-radius: 8px 8px 0 0;

  @media (min-width: 768px) {
    border-bottom: 1px solid #42abe9;
  }

  ${({ active }) =>
    active &&
    `
    border: none;

    @media (min-width: 768px) {
      border-top: 1px solid #42ABE9;
      border-left: 1px solid #42ABE9;
      border-right: 1px solid #42ABE9;
      border-bottom: none;
    }
  `}
`;

export const Tabs = ({ arr, isPublic, classID, gradeName, className = '' }) => (
  <Container className={className}>
    {arr.map(({ heading, link }) => (
      <Tab
        to={
          isPublic
            ? `/math/${link}`
            : `/teachers/g/${classID}/curriculum/${link}`
        }
        key={heading}
        active={link === gradeName ? 1 : 0}
      >
        {heading}
      </Tab>
    ))}
    <FlexGrow />
  </Container>
);

export default Tabs;
